export const FETCH_DBSTATS_STARTED = 'FETCH_DBSTATS_STARTED';
export const FETCH_DBSTATS_SUCCESS = 'FETCH_DBSTATS_SUCCESS';
export const FETCH_DBSTATS_FAILURE = 'FETCH_DBSTATS_FAILURE';

export const FETCH_RSSFEEDS_STARTED = 'FETCH_RSSFEEDS_STARTED';
export const FETCH_RSSFEEDS_SUCCESS = 'FETCH_RSSFEEDS_SUCCESS';
export const FETCH_RSSFEEDS_FAILURE = 'FETCH_RSSFEEDS_FAILURE';

export const FETCH_PREFS_STARTED = 'FETCH_PREFS_STARTED';
export const FETCH_PREFS_SUCCESS = 'FETCH_PREFS_SUCCESS';
export const FETCH_PREFS_FAILURE = 'FETCH_PREFS_FAILURE';

export const UPDATE_PREFS_STARTED = 'UPDATE_PREFS_STARTED';
export const UPDATE_PREFS_SUCCESS = 'UPDATE_PREFS_SUCCESS';
export const UPDATE_PREFS_FAILURE = 'UPDATE_PREFS_FAILURE';
